import React from 'react';
import mixpanel from 'mixpanel-browser';

import { Button } from '@mui/material';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { empoweringLendersSectionObj } from '../../constants/Pages/Landing';

import './EmpoweringLendersSection.css';

export const EmpoweringLendersSection = ({ userId }) => {
  const { title, description, linkText } = empoweringLendersSectionObj;

  return (
    <div className="empowering-partners-section-wrapper">
      <h2 className="empowering-partners-header">{title}</h2>
      <div className="empowering-partners-description">{description}</div>
      <div className="empowering-lenders-section-wrapper">
        {Object.keys(empoweringLendersSectionObj.empoweringLendersContentSection).map(
          (contentHeader) => (
            <div
              className={
                'empowering-lenders-box-content ' +
                empoweringLendersSectionObj.empoweringLendersContentSection[contentHeader]
                  .BOX_CONTENT_CLASSNAME
              }
              key={contentHeader}
              onClick={() => {
                mixpanel.track('Empower Lenders and Providers', {
                  path: '/',
                  distinct_id: userId,
                  sectionContent: contentHeader,
                });
              }}
            >
              {empoweringLendersSectionObj.empoweringLendersContentSection[contentHeader].icon()}
              <h4 className="partner-insights-header"> {contentHeader} </h4>
              <div className="platform-content-description">
                {
                  empoweringLendersSectionObj.empoweringLendersContentSection[contentHeader]
                    .description
                }
              </div>
            </div>
          ),
        )}
      </div>
      <div className="join-our-network-link-wrapper">
        <Button
          sx={{
            '&:hover': { textDecoration: 'none' },
            color: 'white',
            borderRadius: { xs: '0.5rem', md: '0.8rem' },
            backgroundColor: 'black',
            color: 'white',
            textTransform: 'initial',
            padding: 2,
            pl: { xs: 12, md: 5 },
            pr: { xs: 10, md: 3 },
            fontSize: 14,
            fontFamily: 'sans-serif',
            fontWeight: 600,
            textDecoration: 'none',
          }}
          onClick={() => {
            mixpanel.track('Join Our Network', { path: '/', distinct_id: userId });
          }}
          href="/partner"
        >
          {linkText} <ArrowForwardIcon sx={{ ml: 1 }} />
        </Button>
      </div>
    </div>
  );
};
